<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="edit-profile">
          <div class="row">
            <div class="col-12 col-xl-12">
              <div class="card">
                <div class="card-header">
                  <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                    Perfil de {{ form.name  }}
                  </div>
                </div>
                <div class="card-body" style="margin-top: 20px;">
                  <form >
                    <div>
                      <div class="flex gap-8">
                       <!-- Cuadro para mostrar el logo o placeholder -->
                       <div class="w-[342px] h-[342px] bg-neutral-200 rounded-md border border-[#dee2e6] flex justify-center items-center relative overflow-hidden">
                          <!-- Texto inicial, solo visible si no hay imagen -->
                          <span 
                            v-if="!form.img_src" 
                            class="text-neutral-500 text-sm font-medium font-['Poppins'] absolute"
                          >
                            342 x 342
                          </span>
                          <!-- Vista previa de la imagen cargada -->
                          <img 
                            v-else 
                            :src="form.img_src" 
                            class="w-full h-full object-cover" 
                             alt="Vista previa de la imagen" 
                          />
                          <!-- Input para cargar imagen -->
                          <input 
                            id="imageInput"
                            type="file" 
                             accept="image/*" 
                            class="absolute inset-0 opacity-0 cursor-pointer" 
                          />
                        </div>
                        <!-- ID y Nombre -->
                        <div class="flex flex-col gap-4">
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">ID</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.id || "No especificado" }}
                            </div>
                          </div>
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Email</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.email || "No especificado" }}
                            </div>
                          </div>
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Sitio Web</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.website || "No especificado" }}
                            </div>
                          </div>
                        </div>
                        <div class="flex flex-col gap-4">
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                            <a 
                              :href="'https://www.tuin.ai/inmobiliarias/' + form.slug" 
                              class="text-pink-500 text-sm font-light font-['Poppins'] hover:underline"
                              target="_blank" 
                              rel="noopener noreferrer"
                            >
                              {{ form.name || "No especificado" }}
                            </a>
                          </div>
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Teléfono</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.phone || "No especificado" }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex justify-between items-start gap-4">
                        <!-- Columna izquierda -->
                        <div class="flex flex-col gap-4">
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Código Postal</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.zipcode || "No especificado" }}
                            </div>
                          </div>
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Colonia</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.neighborhood || "No especificado" }}
                            </div>
                          </div>
                        </div>
                        <!-- Columna derecha -->
                        <div class="flex flex-col gap-4">
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Estado</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.state || "No especificado" }}
                            </div>
                          </div>
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Calle</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.street || "No especificado" }}
                            </div>
                          </div>
                        </div>
                        <div class="flex flex-col gap-4">
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                            <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Delegación</label>
                            <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                              {{ form.municipality || "No especificado" }}
                            </div>
                          </div>
                          <div class="flex flex-col gap-4">
                            <div class="flex justify-between gap-4">
                              <div class="flex-1 h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                                <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Número Exterior</label>
                                <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                                  {{ form.ext_number || "No especificado" }}
                                </div>
                              </div>
                              <div class="flex-1 h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                                <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Número Interior</label>
                                <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                                  {{ form.int_number || "No especificado" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Descripción -->
                      <div class="w-[716px] h-[168px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Descripción</label>
                        <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                          {{ form.summary || "No especificado" }}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- Mensaje de éxito -->
                <div v-if="successMessage" class="user-alert">
                  <div class="user-alert-content">
                    <div class="user-alert-text">
                      {{ successMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import axios from "axios";
  import { ref, computed, watch, onMounted } from "vue";
  import { useStore } from "vuex";
  //import { useRouter } from "vue-router";
  import { useRoute } from "vue-router";
  
  export default {
    setup() {
      const store = useStore();
      const session = computed(() => store.getters.getUserSession);
      const route = useRoute();
      const companyId = computed(() => route.params.id);  // Obtener el ID del rol desde la URL
      const states = ref([]); // Movido dentro del setup
      const colonies = ref([]);
      const municipalities = ref([]);
      let toastAlert  = ref(false);
      let typeMsg     = ref("");
      let msg         = ref("");

      const form = ref({
        id: "",
        name: "",
        summary: "",
        email: "",       
        phone: "",     
        website: "",      
        slug: "",         
        zipcode: "",   
        ext_number: "",    
        int_number: "",   
        logo: "",         
        neighborhood: "", 
        state: "",       
        municipality: "",
        street: "", 
      });
      const successMessage = ref("");
      //const router = useRouter();
  
      // Función para cargar los datos del rol cuando estamos en modo de edición
      const loadRoleData = async () => {
        if (companyId.value) {
          try {
            const token = session.value.token_api;
            if (!token) {
              console.error("No se ha encontrado el token de autenticación.");
              return;
            }
  
            const options = {
              headers: {
                Authorization: `Bearer ${token}`
              }
            };
  
            // Hacer la solicitud GET para obtener los datos del rol
            const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/company-form/${companyId.value}`, options);
            console.log(response)
            if (response.status === 200) {
              // Asignar los datos al formulario
              form.value.id = response.data.resp.company.id;
              form.value.name = response.data.resp.company.name;
              form.value.summary = response.data.resp.company.summary;
              form.value.email = response.data.resp.company.email;
              form.value.phone = response.data.resp.company.phone;
              form.value.website = response.data.resp.company.website;
              form.value.slug = response.data.resp.company.slug;
              form.value.zipcode = response.data.resp.company.zipcode;
              form.value.img_src = response.data.resp.company.logo;
              
              form.value.int_number = response.data.resp.company.int_number;
              form.value.ext_number = response.data.resp.company.ext_number;
              form.value.street = response.data.resp.company.street;
              form.value.state = response.data.resp.company.state;
              form.value.neighborhood = response.data.resp.company.neighborhood;
              form.value.municipality = response.data.resp.company.municipality;
            }
          } catch (error) {
            console.error("Error al cargar los datos del rol:", error);
          }
        }
      };
  
      // Llamar a la función cuando el componente se monta
      onMounted(() => {
        loadRoleData();
        GetState();
      });

      const GetState = async () => {
          try {
              // Construir la URL de la API desde las variables de entorno
              const url_cnn = `${process.env.VUE_APP_API_BASE_URL}/catalogue/states`;

              // Realizar la solicitud con Axios
              const response = await axios.get(url_cnn, {
                  headers: {
                      'Content-Type': 'application/json', // Establecer el tipo de contenido
                  }
              });

              // Obtener la respuesta y mapearla al formato deseado
              const resp = response.data.resp;
              states.value = resp.map(estado => ({
                  value: estado.id,       // Usando el id como valor
                  name: estado.estado     // Usando el nombre del estado
              }));
              console.log(states.value)
          } catch (error) {
              console.error(error);

              // Manejar errores específicos
              if (error.response && error.response.status === 401) {
                  console.log('Debe cerrar la sesión');
              } else {
                  console.log('Error al obtener los estados');
              }
          }
      };
      const ConsultZip = zipCode => {
        const url_cnn = `${process.env.VUE_APP_API_BASE_URL}/catalogue/cp/${zipCode}`;
        
        const options = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session.value.token_api}` // Reemplaza con el token correcto
          }
        };

        axios.get(url_cnn, options)
          .then(response => {
            const resp = response.data.data;

            // Verifica que el código postal retorne datos
            if (resp.length > 0) {
              // Asignar estado
              
              // Asignar municipio
              municipalities.value = [{
                value: resp[0]['municipio_id'],
                name: resp[0]['municipio'],
              }];

              // Asignar colonia
              if (resp.length === 1) {
                form.value.neighborhood = colonies.value[0].value; // Asignar el ID
              }

              colonies.value = resp.map(colony => ({
                value: colony.colonia_id || colony.id, // Usar el ID de la colonia
                name: colony.colonia
              }));
            } else {
              // Mostrar alerta si no hay resultados
              toastAlert.value = true;
              typeMsg.value = 'danger';
              msg.value = "Verifica tu código postal";
              setTimeout(() => {
                closeToast();
              }, 3000);
            }
          })
          .catch(error => {
            console.error(error);
            if (error.response && error.response.status === 401) {
              console.log('Debe cerrar la sesión');
            }
          });
      };
      
      const closeToast = async () => {
       
      };
        watch(
        () => form.value.zipcode,
        newValue => {
          if (newValue && newValue.length === 5) { // Opcional: valida que el código postal tenga 5 caracteres
            ConsultZip(newValue);
          }
        }
      );
  
      return {
        form,
        states,
        municipalities,
        colonies,
        ConsultZip,
        successMessage
      };
    }
    
  };
  </script>
  